import React from "react";
import styles from "./style.module.scss";
import { AiFillGithub, AiFillLinkedin } from "react-icons/ai";
import { Link } from "react-router-dom";

const Footer = () => {

    const date = new Date();
    const year = date.getFullYear();
  return (
    <div className={styles.footer}>
      <div className={styles.footer_top}>
        <div className={styles.footer_top_left}>
          <img src="/assets/images/logo.png" alt="logo" />
          <div className={styles.footer_social}>
            <Link to={'https://www.linkedin.com/in/mahmoud-odeh-a9399b20a/'} target="_blank" className={styles.footer_social_item}>
              <AiFillLinkedin />
            </Link>
            <Link to={'https://github.com/Mah9988'} target="_blank" className={styles.footer_social_item}>
              <AiFillGithub />
            </Link>
          </div>
        </div>
        <div className={styles.footer_top_right}>
          <Link to="/">Home</Link>
          <a href="/#about">About</a>
          <Link to="/portfolio">Portfolio</Link>
          <Link to="/contact">Contact</Link>
        </div>
      </div>

      <hr className="border-secondary" />

      <div className={styles.footer_top}>
        <div className={styles.footer_top_left}>
          <p>Copyright © Mahmoud Odeh · {year}</p>
  
        </div>
        <div className={styles.footer_top_right}>
            Developed By / <span>Mahmoud Odeh</span>
        </div>
      </div>
    </div>
  );
};
export default Footer;
